// export const API_URL = "http://localhost:3000/api";
export const API_URL = "https://loopback.swg.bruening.dev/api";
export default API_URL;
